import React, {useState, useEffect} from "react";
import { initializeApp, getApps } from "firebase/app";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBAwGsTIxPxh-s4UwqJiIXge8Dc-zt6ivI",
  authDomain: "meitho.firebaseapp.com",
  projectId: "meitho",
  storageBucket: "meitho.firebasestorage.app",
};

const ppApp = getApps().find(a=>a.name==="employee") || initializeApp(firebaseConfig,"employee");
const ppDb = getFirestore(ppApp);

const FF="'Inter','Segoe UI',sans-serif";
const FFD="'DM Sans','Inter',sans-serif";

function calcScore(p){
  let s=0;
  if(p.mobile)s+=60;if(p.aadhaar)s+=70;if(p.pan)s+=50;if(p.email)s+=20;
  const emp=p.employment||[];
  if(emp.length>0){
    const ty=emp.reduce((a,e)=>{const st=new Date(e.joiningDate||"");const en=e.relievingDate?new Date(e.relievingDate):new Date();return a+Math.max(0,(en-st)/(1000*60*60*24*365));},0);
    if(ty>=5)s+=250;else if(ty>=3)s+=180;else if(ty>=1)s+=120;else s+=60;
  }
  const edu=p.education||[];
  if(edu.length>0)s+=edu[0].degree?.toLowerCase().includes("b.tech")||edu[0].degree?.toLowerCase().includes("mba")?120:80;
  s+=Math.min(150,(p.certifications||[]).length*30+(p.skills||[]).length*10);
  const fs=[p.name,p.mobile,p.email,p.city,p.dob,p.designation,p.photo];
  s+=Math.round((fs.filter(Boolean).length/fs.length)*150);
  return Math.min(1000,s);
}

export default function PublicProfile() {
  const [profile,setProfile]=useState(null);
  const [loading,setLoading]=useState(true);
  const meithoId=window.location.pathname.split("/p/")[1]?.split("/")[0];

  useEffect(()=>{
    if(!meithoId){setLoading(false);return;}
    const load=async()=>{
      try{
        const q=query(collection(ppDb,"employeeProfiles"),where("meithoId","==",meithoId));
        const snap=await getDocs(q);
        if(!snap.empty)setProfile(snap.docs[0].data());
      }catch(e){console.warn(e);}
      setLoading(false);
    };
    load();
  },[meithoId]);

  if(loading) return(
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0a0a1a,#1a1a2e)",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:FF}}>
      <div style={{color:"rgba(255,255,255,0.5)"}}>Loading...</div>
    </div>
  );

  if(!profile) return(
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0a0a1a,#1a1a2e)",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:FF}}>
      <div style={{textAlign:"center",color:"rgba(255,255,255,0.5)"}}>
        <div style={{fontSize:40,marginBottom:12}}>🔍</div>
        <div style={{fontSize:16}}>Profile not found</div>
        <div style={{fontSize:12,marginTop:8}}>ID: {meithoId}</div>
      </div>
    </div>
  );

  const score=calcScore(profile);
  const color=score>=850?"#10b981":score>=700?"#0cc0df":score>=550?"#8b5cf6":score>=400?"#ff914d":"#ef4444";
  const grade=score>=850?"Elite":score>=700?"Excellent":score>=550?"Good":score>=400?"Fair":"Building";

  return(
    <div style={{minHeight:"100vh",background:"linear-gradient(180deg,#0a0a1a,#0d0d1f)",fontFamily:FF,maxWidth:480,margin:"0 auto"}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#0a0a1a,#1a1a2e)",padding:"40px 24px 24px",textAlign:"center",borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:20}}>
          <div style={{width:24,height:24,borderRadius:6,background:"linear-gradient(135deg,#ff3131,#ff914d)",display:"flex",alignItems:"center",justifyContent:"center"}}>
            <svg width="12" height="12" viewBox="0 0 20 20" fill="none"><path d="M10 2L4 5v5c0 3.55 2.57 6.87 6 7.74C13.43 16.87 16 13.55 16 10V5l-6-3z" fill="white"/></svg>
          </div>
          <div style={{fontSize:12,color:"rgba(255,255,255,0.4)",fontWeight:600}}>MEITHO VERIFIED PROFILE</div>
        </div>
        <div style={{width:80,height:80,borderRadius:"50%",background:"linear-gradient(135deg,#ff3131,#ff914d)",border:"3px solid rgba(12,192,223,0.4)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:32,fontWeight:700,color:"#fff",margin:"0 auto 14px"}}>
          {(profile.name||"?")[0]?.toUpperCase()}
        </div>
        <div style={{fontFamily:FFD,fontSize:24,fontWeight:800,color:"#fff",marginBottom:4}}>{profile.name}</div>
        <div style={{fontSize:13,color:"rgba(255,255,255,0.5)",marginBottom:2}}>{profile.designation}</div>
        <div style={{fontSize:12,color:"rgba(255,255,255,0.3)"}}>{profile.currentCompany} {profile.city?`· ${profile.city}`:""}</div>
        <div style={{fontSize:10,color:"#0cc0df",fontWeight:600,marginTop:8,fontFamily:"monospace"}}>{profile.meithoId}</div>
      </div>

      {/* Score */}
      <div style={{margin:"20px 24px",background:"rgba(255,255,255,0.04)",borderRadius:16,padding:20,border:"1px solid rgba(255,255,255,0.08)"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <div style={{fontSize:10,color:"rgba(255,255,255,0.3)",letterSpacing:1,marginBottom:6}}>MEITHO SCORE</div>
            <div style={{fontFamily:FFD,fontSize:48,fontWeight:900,color,lineHeight:1}}>{score}</div>
            <div style={{fontSize:13,color,fontWeight:700,marginTop:4}}>{grade}</div>
            <div style={{fontSize:10,color:"rgba(255,255,255,0.3)",marginTop:2}}>out of 1000</div>
          </div>
          <div style={{width:100,height:100,position:"relative"}}>
            <svg width="100" height="100" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="10"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke={color} strokeWidth="10"
                strokeDasharray={`${(score/1000)*251.2} 251.2`} strokeLinecap="round"
                transform="rotate(-90 50 50)"/>
            </svg>
            <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:FFD,fontSize:20,fontWeight:900,color}}>{score}</div>
          </div>
        </div>
      </div>

      {/* Verified badges */}
      <div style={{margin:"0 24px 20px",display:"flex",gap:8,flexWrap:"wrap"}}>
        {[
          {l:"Identity",done:!!(profile.aadhaar&&profile.pan)},
          {l:"Employment",done:!!(profile.employment?.length>0)},
          {l:"Education",done:!!(profile.education?.length>0)},
        ].map(b=>(
          <div key={b.l} style={{fontSize:11,fontWeight:600,padding:"5px 12px",borderRadius:99,background:b.done?"rgba(16,185,129,0.12)":"rgba(255,255,255,0.04)",border:`1px solid ${b.done?"rgba(16,185,129,0.3)":"rgba(255,255,255,0.08)"}`,color:b.done?"#10b981":"rgba(255,255,255,0.3)"}}>
            {b.done?"✓":"○"} {b.l}
          </div>
        ))}
      </div>

      {/* Employment */}
      {profile.employment?.length>0&&(
        <div style={{margin:"0 24px 20px"}}>
          <div style={{fontSize:11,color:"rgba(255,255,255,0.4)",fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:12}}>Experience</div>
          {profile.employment.slice(0,3).map((e,i)=>(
            <div key={i} style={{background:"rgba(255,255,255,0.03)",borderRadius:10,padding:"12px 14px",marginBottom:8,border:"1px solid rgba(255,255,255,0.06)"}}>
              <div style={{fontSize:13,fontWeight:700,color:"#fff"}}>{e.designation}</div>
              <div style={{fontSize:12,color:"rgba(255,255,255,0.5)"}}>{e.company}</div>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.3)",marginTop:2}}>{e.joiningDate} → {e.relievingDate||"Present"}</div>
            </div>
          ))}
        </div>
      )}

      {/* Education */}
      {profile.education?.length>0&&(
        <div style={{margin:"0 24px 20px"}}>
          <div style={{fontSize:11,color:"rgba(255,255,255,0.4)",fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:12}}>Education</div>
          {profile.education.slice(0,2).map((e,i)=>(
            <div key={i} style={{background:"rgba(255,255,255,0.03)",borderRadius:10,padding:"12px 14px",marginBottom:8,border:"1px solid rgba(255,255,255,0.06)"}}>
              <div style={{fontSize:13,fontWeight:700,color:"#fff"}}>{e.degree} {e.branch?`· ${e.branch}`:""}</div>
              <div style={{fontSize:12,color:"rgba(255,255,255,0.5)"}}>{e.institution}</div>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.3)",marginTop:2}}>{e.year} {e.percentage?`· ${e.percentage}`:""}</div>
            </div>
          ))}
        </div>
      )}

      {/* Share */}
      <div style={{margin:"0 24px 40px"}}>
        <button onClick={()=>{
          const url=`https://meitho.com/p/${meithoId}`;
          navigator.clipboard?.writeText(url);
          alert("Profile link copied!");
        }} style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,color:"rgba(255,255,255,0.7)",padding:"12px",cursor:"pointer",fontSize:13,fontWeight:600,fontFamily:FF}}>
          🔗 Share Profile
        </button>
      </div>

      <div style={{textAlign:"center",padding:"0 0 30px",fontSize:11,color:"rgba(255,255,255,0.2)"}}>
        Powered by Meitho BGV · meitho.com
      </div>
    </div>
  );
}
